/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import MarketoForm from '.';

export const BlueMarketoForm = styled(MarketoForm)`
  background-color: var(--blue-primary);

  .signup-form--title {
    color: var(--white-color);
  }

  .signup-form--footer,
  .signup-form--footer-1 {
    color: var(--white-color);

    & > a {
      color: var(--white-color);
    }
  }

  .radio-field--title {
    color: var(--white-color);
  }

  .radio-div {
    background-color: var(--white-color);

    &.selected label,
    input:checked + label,
    &.selected:last-child label {
      border: 3px solid var(--white-color);
    }
  }
  .ant-row {
    .st-slider-field--title {
      color: var(--white-color);
    }
    .st-slider-description {
      color: var(--blue-3);
    }
    .ant-slider-handle {
      color: var(--white-color);
    }
    .ant-slider-track {
      background-color: var(--blue-3);
    }
  }

  .marketo-embedded--container {
    background-color: var(--blue-primary);

    .marketo-embedded--form-title {
      color: var(--white-color);
    }

    form.mktoForm {
      .mktoFormRow {
        .mktoLabel {
          color: var(--white-color);
        }

        select.mktoField {
          background-color: var(--white-color);
        }

        .mktoRadioList {
          & > label {
            background-color: var(--white-color);

            &:hover {
              background-color: var(--white-hover-color);
            }
          }

          input:checked + label {
            border: 1px solid var(--white-color);
          }
        }
      }

      .mktoButtonRow {
        .mktoButtonWrap {
          width: 100%;
        }
      }
    }
  }
`;
